'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _errorModalConstants = require('./errorModalConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Lib
var initialState = Immutable.Map();

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _errorModalConstants.ERROR_MODAL_OPEN:
            return action.data ? Immutable.fromJS(action.data) : initialState;
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/error/modals/errorModalDataReducer.js
// module id = 1769
// module chunks = 0